import React from "react";
import { useDispatch } from "react-redux";
import { updateMode } from "../../redux/reducers/ModeReducer";
import ButtonNext from "../../assets/images/others/ButtonNext3.png";
import ButtonBack from "../../assets/images/others/ButtonBack3.png";
import ButtonSpeaker from "../../assets/images/others/ButtonSpeaker.png";
import ContentContainer from "../../components/ContentContainerComp/ContentContainer";
import s from "./style.module.css";
const Tutorial = () => {
  const dispatch = useDispatch();
  return (
    <ContentContainer
      audioLink={
        "https://firebasestorage.googleapis.com/v0/b/gamification-756f3.appspot.com/o/audio%2Ftutorial.m4a?alt=media&token=a735bc4a-7c17-4e4c-a879-248df47bd1c9"
      }
      typeHeader={1}
      onCenter
      textHeader="สิ่งที่ควรรู้"
      disableBack={1}
      onPressNext={() => dispatch(updateMode({ mode: 1, step: 5 }))}
    >
      <div className={s.tutorialContainer}>
        <div className={s.tutorialContent}>
          <ol>
            <li>
              กด <img src={ButtonSpeaker} alt="ButtonSpeaker" /> เพื่อฟังเสียง
            </li>
            <li>
              กด <img src={ButtonNext} alt="ButtonNext" /> เพื่อไปหน้าต่อไป
            </li>
            <li>
              กด{" "}
              <img
                style={{ filter: "grayScale(40%)" }}
                src={ButtonBack}
                alt="ButtonBack"
              />{" "}
              เพื่อย้อนกลับ
            </li>
          </ol>
        </div>
      </div>
    </ContentContainer>
  );
};

export default Tutorial;
